<template>
  <div class="logos-container">
    <img
      class="logo"
      :src="require(`@/assets/images/${logo.default}`)"
      :alt="logo.name"
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { applicationStoreTypes } from '@/store/types';
import themes from '@/config/themes';
import checkIfIsBecomeDomain from '@/scripts/checkIfIsBecomeDomain';

export default {
  name: 'BrandLogo',
  computed: {
    ...mapGetters({
      unitName: applicationStoreTypes.getters.UNIT_NAME,
      unit: applicationStoreTypes.getters.UNIT,
    }),
    logo() {
      return {
        name: `${this.unit.name}`,
        default: checkIfIsBecomeDomain() ? themes.become.logo : 'login/sword/logo-primary.svg',
      };
    },
  },
};
</script>
<style lang="scss" scoped>
  .logos-container {
    display: flex;
    align-items: center;

    @media screen and (max-width: $max-smartphone-size) {
      justify-content: center;
    }

    img.company-logo {
      max-width: 6.25rem;
      max-height: 2.5rem;
    }

    .logo {
      width: 97px;
      max-height: 24px;
    }
  }

  .divider {
    width: 1px;
    height: 2rem;
    border-right: 1px solid $negative-color-dark;
    margin: 0 10px;
  }
</style>
